module.exports = __webpack_public_path__ + "img/bp010.bc7c59fd.jpg";